import React from 'react';
import { Image } from 'components/atoms/image';

const NewsCard = props => {
  const { data } = props;
  return (
    <div className={'news-card-body'}>
      <div className={'poster-container'}>
        <div className={'image-container'}>
          {data.pdf_path ? (
            <a onClick={() => window.open(data.pdf_path)}>
              <Image
                src={data.picture}
                alt="News"
                thumbNail={data.media_path_thumbnail}
              />
            </a>
          ) : (
            <Image
              src={data.picture}
              alt="News"
              thumbNail={data.media_path_thumbnail}
            />
          )}
        </div>
        <div className={'title-container'}>
          <span className={'published-date'}>{data.published_on}</span>
          <h2 className={'title'}>{data.title}</h2>
        </div>
      </div>
      <p className={'description'}>{data.description}</p>
    </div>
  );
};
export default NewsCard;
